// VATs action types
export const SET_VATs_DATA = "SET_VATs_DATA";
export const ADD_VAT = "ADD_VAT";
export const UPDATE_VAT = "UPDATE_VAT";
export const DELETE_VAT = "DELETE_VAT";
